// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:26-08-2025
// LAST ADD: DESTRUCTING PAYLOAD VALUES
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	// ADD ACCOUNT DETAILS
	addAccountDetailsFailure,
	addAccountDetailsResponseChanged,
	addAccountDetailsSuccess,
	// DELETE ACCOUNT DETAILS
	deleteAccountDetailsFailure,
	deleteAccountDetailsResponseChanged,
	deleteAccountDetailsSuccess,
	// GET ACCOUNT LIST
	getAccountListFailure,
	getAccountListResponseChanged,
	getAccountListSuccess,
	// UPDATE ACCOUNT DETAILS
	updateAccountDetailsFailure,
	updateAccountDetailsResponseChanged,
	updateAccountDetailsSuccess,
} from './account.action';
import AccountType from './account.types';
import {
	accountDetailsAdd,
	accountDetailsDelete,
	accountDetailsUpdate,
	accountListGet,
} from './account.services';

/***********************  START GET ACCOUNT LIST  ******************** */
export function* accountDetailsListGet({ payload }: any) {
	try {
		const { databaseName, inputSearch, infogCompanyID, limit } = payload;
		const key = 'GetAllAccountListKey';
		const jsonData = {
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			InfogID: infogCompanyID,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAccountListFailure(responseData.data));
		} else {
			yield put(getAccountListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAccountListFailure(error));
	}
}

export function* resetGetAccountListResponse() {
	yield put(getAccountListResponseChanged());
}

export function* onGetAccountListDetails() {
	yield takeLatest(AccountType.GET_ACCOUNT_LIST_START, accountDetailsListGet);
}

export function* onGetAccountListResponseReset() {
	yield takeLatest(AccountType.GET_ACCOUNT_LIST_RESPONSE_RESET, resetGetAccountListResponse);
}
/** *********************  END GET ACCOUNT LIST ******************** */

/** *********************  START ADD ACCOUNT DETAILS  ******************** */
export function* createAccount({ payload }: any) {
	try {
		const {
			infogCompanyID,
			userID,
			userName,
			databaseName,
			groupAccount,
			groupSubAccount,
			accountCode,
			accountName,
			openingBalanceType,
			date,
			hsnCode,
			CGSTRate,
			igstRate,
			cessRate,
			gstExempt,
			RCMApply,
			companyID,
			branchID,
			sgstRate,
			allBranchApply,
		} = payload;
		const key = 'CreateAccountKey';
		const jsonData = {
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			CreatedModifiedBy: userID,
			UserName: userName,
			GroupAccountID: groupAccount,
			SubGroupAccountID: groupSubAccount,
			AccountCode: accountCode,
			AccountName: accountName,
			OpeningBalanceType: openingBalanceType,
			OpeningBalanceDate: date,
			HsnCode: hsnCode,
			CgstRate: CGSTRate,
			IgstRate: igstRate,
			CessRate: cessRate,
			SelectedSubGroupAccountID: groupSubAccount,
			GstExempt: gstExempt,
			RcmApply: RCMApply,
			IsBranchAccountMap: 'false',
			CompanyID: companyID,
			SelectedBranchID: branchID,
			SgstRate: sgstRate,
			UserID: userID,
			AllBranchApply: allBranchApply,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addAccountDetailsFailure(responseData.data));
		} else {
			yield put(addAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addAccountDetailsFailure(error));
	}
}

export function* resetAddAccountResponse() {
	yield put(addAccountDetailsResponseChanged());
}

export function* onCreateAccountDetails() {
	yield takeLatest(AccountType.ADD_ACCOUNT_DETAILS_START, createAccount);
}

export function* onCreateAccountResponseReset() {
	yield takeLatest(AccountType.ADD_ACCOUNT_DETAILS_RESPONSE_RESET, resetAddAccountResponse);
}
/** *********************  END ADD ACCOUNT DETAILS ******************** */

/** *********************  START UPDATE ACCOUNT DETAILS  ******************** */
export function* accountUpdate({ payload }: any) {
	try {
		const {
			infogCompanyID,
			userID,
			userName,
			databaseName,
			groupAccount,
			groupSubAccount,
			accountCode,
			accountName,
			openingBalanceType,
			date,
			hsnCode,
			CGSTRate,
			igstRate,
			cessRate,
			gstExempt,
			RCMApply,
			companyID,
			branchID,
			sgstRate,
			accountID,
		} = payload;
		const key = 'UpdateAllAccountListKey';
		const jsonData = {
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
			CreatedModifiedBy: userID,
			UserName: userName,
			GroupAccountID: groupAccount,
			SubGroupAccountID: groupSubAccount,
			AccountCode: accountCode,
			AccountName: accountName,
			OpeningBalanceType: openingBalanceType,
			OpeningBalanceDate: date,
			HsnCode: hsnCode,
			CgstRate: CGSTRate,
			IgstRate: igstRate,
			CessRate: cessRate,
			SelectedSubGroupAccountID: groupSubAccount,
			GstExempt: gstExempt,
			RcmApply: RCMApply,
			IsBranchAccountMap: 'false',
			CompanyID: companyID,
			SelectedBranchID: branchID,
			SgstRate: sgstRate,
			UserID: userID,
			AccountID: accountID,
			AllBranchApply: '0',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAccountDetailsFailure(responseData.data));
		} else {
			yield put(updateAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAccountDetailsFailure(error));
	}
}

export function* resetUpdateAccountDetailsResponse() {
	yield put(updateAccountDetailsResponseChanged());
}

export function* onUpdateAccountDetails() {
	yield takeLatest(AccountType.UPDATE_ACCOUNT_DETAILS_START, accountUpdate);
}

export function* onUpdateAccountResponseReset() {
	yield takeLatest(
		AccountType.UPDATE_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetUpdateAccountDetailsResponse,
	);
}
/** *********************  END UPDATE ACCOUNT DETAILS ******************** */

/** *********************  START DELETE ACCOUNT DETAILS  ******************** */
export function* accountDelete({ payload }: any) {
	try {
		const { userID, branchID, AccountID, AccountName, companyID, SubGroupAccountID, userName } =
			payload;
		const key = 'DeleteAccountKey';
		const jsonData = {
			UserID: userID,
			BranchID: branchID,
			AccountID: AccountID,
			AccountName: AccountName,
			CompanyID: companyID,
			SubGroupAccountID: SubGroupAccountID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(accountDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteAccountDetailsFailure(responseData.data));
		} else {
			yield put(deleteAccountDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteAccountDetailsFailure(error));
	}
}

export function* resetDeleteAccountDetailsResponse() {
	yield put(deleteAccountDetailsResponseChanged());
}

export function* onDeleteAccountDetail() {
	yield takeLatest(AccountType.DELETE_ACCOUNT_DETAILS_START, accountDelete);
}

export function* onDeleteAccountResponseReset() {
	yield takeLatest(
		AccountType.DELETE_ACCOUNT_DETAILS_RESPONSE_RESET,
		resetDeleteAccountDetailsResponse,
	);
}
/** *********************  END DELETE ACCOUNT DETAILS  ******************** */

export function* accountSaga() {
	yield all([
		// ADD ACCOUNT DETAILS
		call(onCreateAccountDetails),
		call(onCreateAccountResponseReset),
		// UPDATE ACCOUNT DETAILS
		call(onUpdateAccountDetails),
		call(onUpdateAccountResponseReset),
		// GET ACCOUNT LIST
		call(onGetAccountListDetails),
		call(onGetAccountListResponseReset),
		// DELETE ACCOUNT DETAILS
		call(onDeleteAccountDetail),
		call(onDeleteAccountResponseReset),
	]);
}
